import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/max';

export default class phoneValidator {
    validate(value, country) {
        const countryUppercase = country.toUpperCase()
        const valid = isValidPhoneNumber(value, countryUppercase);

        if (!valid) return false;

        const phoneNumber = parsePhoneNumber(value, countryUppercase);

        return phoneNumber.country === countryUppercase;
    }
}
